export interface PagingInfo {
  page: number;
  pageSize: number;
  noPaging?: boolean;
}

export interface PagedData<T> extends PagingInfo {
  page: number;
  pageSize: number;
  total: number;
  items: T[];
}

export const PagedData = {
  Empty<T>(): PagedData<T> {
    return {
      page: 1,
      pageSize: 20,
      total: 0,
      items: [],
    };
  },
};
